import { pubsub } from '@services';

class PriceElement extends HTMLElement {
  connectedCallback() {
    this.unsubscribeVariantChange = pubsub.subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        this.handlePriceChange(html);
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handlePriceChange(html) {
    const priceElement = html.querySelector('price-element');
    this.innerHTML = priceElement.innerHTML;
  }
}

customElements.define('price-element', PriceElement);
